import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from './posthog';

const RouteTracker = () => {
  const location = useLocation();
  const prevPathRef = useRef(null);
  const entryTimeRef = useRef(Date.now());

  useEffect(() => {
    const currentPath = location.pathname;
    const now = Date.now();

    if (prevPathRef.current !== null && prevPathRef.current !== currentPath) {
      const duration = (now - entryTimeRef.current) / 1000;
      posthog.capture('$pageleave', {
        $current_url: window.location.origin + prevPathRef.current,
        $prev_pageview_pathname: prevPathRef.current,
        $prev_pageview_duration: duration,
      });
    }

    posthog.capture('$pageview', {
      $current_url: window.location.href,
      path: currentPath,
    });

    prevPathRef.current = currentPath;
    entryTimeRef.current = now;
  }, [location.pathname]);

  return null;
};

export default RouteTracker;
